// extracted by mini-css-extract-plugin
export var deliveryRow = "_r0-a";
export var fixedHeight = "_r0-4";
export var freightLogo = "_r0-9";
export var fullWidth = "_r0-3";
export var priceColumn = "_r0-5";
export var radioSelected = "_r0-7";
export var radioUnselected = "_r0-6";
export var selectedOption = "_r0-2";
export var selectedOptionContainer = "_r0-1";
export var selection = "_r0-0";
export var tallSkeletonText = "_r0-8";